import { MarkedExtension } from 'marked';
import { DOCS_BASE_URLS } from './docs-links.extension';

// Note: In marked, the LAST extension loaded has highest priority.
// docsLinksExtension is loaded after this, so it handles docs links first.
// This extension returns false for docs links to ensure proper fallback chain.

export function externalLinksExtension(baseUrl?: string): MarkedExtension {
  return {
    renderer: {
      link(href: string, title: string | null | undefined, text: string): string | false {
        // Let docsLinksExtension handle docs.zerops.io links
        if (DOCS_BASE_URLS.some((base) => href.startsWith(base))) {
          return false;
        }

        // Check if it's a pure anchor link (starts with #)
        const isAnchor = href.startsWith('#');

        // Check if it's a same-page anchor (contains # but points to current page)
        const hasHash = href.includes('#');
        let isSamePageAnchor = false;

        if (hasHash && !isAnchor) {
          // Extract the part before the hash
          const urlBeforeHash = href.split('#')[0];
          // Check if it's the same origin or empty (relative)
          try {
            const hrefUrl = new URL(href, window.location.href);
            const currentUrl = new URL(window.location.href);
            isSamePageAnchor = hrefUrl.origin === currentUrl.origin &&
                              hrefUrl.pathname === currentUrl.pathname;
          } catch {
            // If URL parsing fails, treat as relative
            isSamePageAnchor = !urlBeforeHash || urlBeforeHash === window.location.pathname;
          }
        }

        // Determine if link is truly external
        const isExternal = !isAnchor && !isSamePageAnchor && (
          href.startsWith('http://') ||
          href.startsWith('https://') ||
          (baseUrl && !href.startsWith(baseUrl))
        );

        const titleAttr = title ? ` title="${title}"` : '';
        const targetAttr = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';
        const classAttr = isExternal ? ' class="markdown-external-link"' : '';

        return `<a href="${href}"${titleAttr}${targetAttr}${classAttr}>${text}</a>`;
      }
    }
  };
}
